/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// utils
import { generateClasses, generatePropsOnChildren } from 'utils/generators';
// material
import MenuIndicator from 'material/menu/menuindicator/menuindicator_container';
// styles
import injectSheet from 'react-jss';
import styles from 'material/menu/menu_styles';



/* ========== ~~~~~~~~~~ MENU : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class Menu extends Component {
	constructor(props) {
		super(props);
		this.state = { active: false }
	}
	componentWillMount() {
        document.addEventListener('mousedown', this.handleOutsideClick, false);
    }
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleOutsideClick, false);
    }
    handleOutsideClick = (e) => {
        if (this.node.contains(e.target)) { return; }
        this.setState({ active: false });
    };
	handleIndicatorClick = (e) => this.setState({ active: this.state.active ? false : true });
	displayChildren = () => {
		return generatePropsOnChildren(this.props.children, {
			updateMenuState: (e) => this.setState({ active: false })
		});
	}
	render() {
		return (
	        <div className={`menu ${generateClasses(this.props)} ${this.props.classes.menu} active-${this.state.active}`}>
	        	<MenuIndicator toggleMenu={this.handleIndicatorClick}>{this.props.indicator}</MenuIndicator>
	        	<div className={`menuitems`} ref={node => {this.node=node;}}>
	        		<span className={`arrow`} />
	        		<div className={`items`}>
	        			{this.displayChildren()}
	        		</div>
	        	</div>
	        </div>
		);
	}
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Menu);